import React from 'react';
import RegisterForm from '../components/Auth/RegisterForm';
import '../styles/RegisterPage.css';

const RegisterPage = () => {
  return (
    <div className="register-page">
      <div className="energy-field-register">
        <div className="energy-bolt-register"></div>
        <div className="energy-bolt-register"></div>
        <div className="energy-bolt-register"></div>
        <div className="energy-node-register"></div>
        <div className="energy-node-register"></div>
        <div className="energy-node-register"></div>
      </div>

      <div className="register-container">
        <div className="register-welcome">
          <h1 className="register-title">REANIMEITOR</h1>
          <p className="register-subtitle">
            Únete a la revolución energética
          </p>
        </div>

        <div className="register-benefits">
          <div className="benefit-item">
            <div className="benefit-icon">🎁</div>
            <p className="benefit-text">Token de Bienvenida</p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">⚡</div>
            <p className="benefit-text">Energía Gratis</p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">💎</div>
            <p className="benefit-text">Ventajas Exclusivas</p>
          </div>
        </div>

        <RegisterForm />
      </div>
    </div>
  );
};

export default RegisterPage;